import React from 'react'
import './register.less'
import { Input, Button, message, Select, Form, Checkbox } from 'antd';
import ysxieyi from './ysxieyi.jsx';
import xieyi from './xieyi.jsx'
import safe from './safe'
import api from '../../api/api';
import {API_CONFIG} from '../../api/config.js'

class Signed extends React.Component {
    state = {
        group_name: '',
        teamList: [],
        checked: false,
        loading: false,
    }
    componentDidMount() {
        let list = sessionStorage.getItem('team') ? JSON.parse(sessionStorage.getItem('team')) : '';
        list = list || [];
        this.setState({ teamList: list });
    }
    handleSubmit = () => {
        if(!this.state.checked){
            message.error('请阅读并同意 《法律声明及隐私权政策》《物业云平台服务协议》《订单共享与安全》')
            return
        }
        this.props.form.validateFields((err, values, callback) => {
            if (err) return;
            this.setState({
                loading: true
            })
            api.create_group({
                name: values.group_name || '',
                source: sessionStorage.getItem('source')==='undefined'?'cgj':sessionStorage.getItem('source'),
                access_token: sessionStorage.getItem('access_token')
            }).then(res => {
                this.setState({
                    loading: false
                })
                if (res.code === 0) {
                    api.get_company_login({
                        access_token: sessionStorage.getItem('access_token'),
                        corp_uuid:res.content.corp_uuid,
                        source: sessionStorage.getItem('source')==='undefined'?'cgj':sessionStorage.getItem('source'),
                    }).then(res=>{
                        if(res.code===0){
                            sessionStorage.setItem('company_token',res.content.access_token)
                            document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                            if(sessionStorage.getItem('market_url')){
                                let market_url = sessionStorage.getItem('market_url')
                                window.location.href=`${market_url}`
                            } else {
                                window.location.href=`${API_CONFIG.yun_base}`
                            }
                        }
                    })
                }
            }).catch(err => {
                this.setState({
                    loading: false
                })
            })
        })
      
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { teamList, loading, checked } = this.state;
        const teamText = teamList.map((item )=> item.name).join('、')
        return (
        <div   style={{     boxShadow:'0 0  15px rgba(176,176,176,0.35)' ,padding:'30px 30px 15px 30px'}}>
           <div className='top'>
                <div className='tip-text'>
                    你已注册过
                    <Button
                    style={{marginLeft:10,height:28}}
                        onClick={() => {
                            if(teamList.length > 1) {
                                this.props.history.push(`/login?has_team=${this.props.has_team}`)
                            } else {
                                api.get_company_login({
                                    access_token: sessionStorage.getItem('access_token'),
                                    corp_uuid: teamList[0].id,
                                    source:sessionStorage.getItem('source')
                                }).then(res=>{
                                    this.setState({grounpLoading: false})
                                    if(res.code===0) {
                                        sessionStorage.setItem('company_token',res.content.access_token)
                                        document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                                        if(sessionStorage.getItem('market_url')){
                                            let market_url = sessionStorage.getItem('market_url')
                                            window.location.href=`${market_url}`
                                        } else {
                                            window.location.href=`${API_CONFIG.yun_base}`
                                        }
                                    }
                                })
                            }
                            
                        }}
                    >去登录</Button>
                </div>
               {this.props.has_team ? 
                <div>
                   <span className='detail-text' title={teamText+ '等' + teamList.length + '个团队'}> 
                    你已加入{teamText}等{teamList.length}个团队。
                   </span>
                   <span></span>
                </div> : ''
                }
            </div>
            <Form style={{paddingTop: 30}}>
                <Form.Item label="或者继续创建新企业" className='item'>
                {getFieldDecorator('group_name', {
                    rules: [{ required: true, message: '请输企业名称' }],
                })(<Input placeholder='请输入企业名称' />)}
                </Form.Item>
                <Button  style={{width:290,marginBottom:5,marginTop:20}}  type='primary' className='register-btn' onClick={this.handleSubmit} loading={loading}>创建企业</Button>
                <div >
                <Checkbox
                    checked={checked} 
                    onChange={() => {
                        this.setState({
                            checked: !checked
                        })
                    }}
                >
                    已阅读并同意 
                    <a onClick={()=>{ysxieyi();}}>《法律声明及隐私权政策》</a>
                    <a onClick={()=>{xieyi();}}>《物业云平台服务协议》</a>
                    <a onClick={()=>{safe();}}>《订单共享与安全》</a>
                </Checkbox>
                </div>
            </Form>
          
        </div>
        )
    }
}
export default Form.create({})(Signed);


// WEBPACK FOOTER //
// ./src/pages/register/Signed.jsx